<svelte:options customElement={{ tag: "app-twofactor", shadow: "none" }} />

<script>
  import { onMount } from "svelte";

  let userHas2FASetup = true;
  let generatedQrCode = "";
  let error = null;
  let generatedKey = "";
  let token = "";

  async function init() {
    userHas2FASetup = await window.api.authentication.userHas2FASetup.query();

    if (!userHas2FASetup) {
      generatedQrCode = await window.api.authentication.generateQrCode.query();
      generatedKey = generatedQrCode.generatedKey;
    }
  }

  async function verifyToken() {
    const result = await window.api.authentication.verifyToken.mutate({
      generatedKey: generatedKey,
      token: String(token),
    });

    if (result.valid) {
      document.cookie = result.cookieData;
      location.reload();
    } else {
      error = "Token is invalid";
    }
  }

  onMount(async () => await init());
</script>

<div class="container container-tight py-4">
  <div class="text-center mb-4">
    <a href="/" class="navbar-brand navbar-brand-autodark">
      <img
        src="https://gamepoint.tech/images/common/logos/logo_gpinternational_frontpage.png"
        alt=""
        width="300"
      />
    </a>
  </div>

  {#if error != null}
    <div class="alert alert-danger">{error}</div>
  {/if}

  <div class="card card-md">
    <div class="card-body">
      <h2 class="h2 text-center mb-4">Two factor authentication</h2>

      {#if userHas2FASetup}
        <form on:submit|preventDefault={verifyToken}>
          <div class="mb-3">
            <label class="form-label" for="token">Token</label>
            <input
              type="text"
              id="token"
              name="token"
              class="form-control"
              data-mask="000000"
              data-mask-visible="true"
              placeholder="123456"
              autocomplete="one-time-code"
              bind:value={token}
            />
          </div>
          <div class="mb-3">
            <button type="submit" class="btn btn-primary ms-auto">Verify</button>
            or
            <a href="/logout" class="btn btn-4">Go back</a>
          </div>
        </form>
      {:else}
        <div class="mb-3 text-center">
          Scan the QR code with an Authenticator app:
          <img
            alt="QR-Code"
            class="mx-auto d-block"
            src={generatedQrCode.totpUri}
          />
        </div>

        <div class="mb-3 text-center">
          Or manually insert in the Authenticator app:
          <input
            type="text"
            class="form-control"
            id="generatedKey"
            placeholder="Disabled..."
            value={generatedQrCode.generatedKey}
            disabled=""
          />
        </div>

        <hr />
        <form on:submit|preventDefault={verifyToken}>
          <div class="mb-3">
            <label class="form-label" for="token">Verify the code from the Authenticator app below</label>
            <input
              type="text"
              id="token"
              name="token"
              class="form-control"
              data-mask="000000"
              data-mask-visible="true"
              placeholder="123456"
              autocomplete="off"
              bind:value={token}
            />
          </div>
          <div class="mb-3">
            <button type="submit" class="btn btn-primary ms-auto">Verify</button>
            <a href="/2fa" class="btn btn-link">Refresh</a>
          </div>
        </form>
      {/if}
    </div>
  </div>
</div>
